

module.config(function($stateProvider) {
    $stateProvider.state('settings.user', {
        url: '/user',
        templateUrl: 'settings/user',
        controller: function($scope, Principal) {
            var token;

            $scope.createToken = function() {
                return Principal.getAPIToken().then(function(t) {
                    token = t;
                });
            }

            $scope.showToken = function() {
                console.log(token);
                $scope.token = token;
            }

        },
    });
});

module.directive('myAccountForm', function(makeBasicForm, Principal) {
    return makeBasicForm({
        templateUrl: 'settings/myAccountForm',
        scope: {},
        data: {user: Principal},
        copyData: function() {
            return  {
                username: Principal.username,
                email: Principal.email,
                first_name: Principal.first_name,
                last_name: Principal.last_name,
            }
        },
        save: function(scope, data) {
            return Principal.update(data);
        },
    });
});


module.directive('changePasswordForm', function($q, makeBasicForm, Principal) {
    return makeBasicForm({
        templateUrl: 'settings/changePasswordForm',
        scope: {},
        copyData: function() {return {}; },
        save: function(scope, data) {
            return Principal.update(data).catch(function(error) {
                scope.basicForm.errorMessage = error.data.message;
                data.current = "";
                return $q.reject(error)
            });
        },
    });
});
